<template>
  <section :id="id">
    <h3>{{ type }}</h3>
    <ul>
      <directory-item v-for="font in fonts" :key="font.family"
        :family="font.family"
        :foundry="font.foundry"
        :download="font.download"
      />
    </ul>
  </section>
</template>

<script>
import DirectoryItem from './DirectoryItem';
  export default {
    name: 'directory-section',
    components: {
      'directory-item': DirectoryItem
    },
    props: {
      type: String,
      id: String,
      fonts: Array
    }
  }
</script>

<style lang="scss" scoped>
  section {
    max-width: 45rem;
    padding: 0 1.5rem;
    margin: 0 auto 4rem auto;
    background: #fff;
  }
  h3 {
    font-size: 1.25rem;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 1.5rem;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
</style>